import { apiClient } from "./client";
import type { Paginated, PageQuery } from "@/types/common";
import type { GroupSuggestion, Lead, LeadConvertInput, LeadCreateInput } from "@/types/lead";
import type { LeadStage } from "@/types/enums";

export interface LeadsQuery extends PageQuery {
  branchId?: string;
  stage?: LeadStage;
  overdue?: boolean;
  search?: string;
}

export async function fetchLeads(query: LeadsQuery): Promise<Paginated<Lead>> {
  const { data } = await apiClient.get<Paginated<Lead>>("/leads", { params: query });
  return data;
}

export async function fetchLead(id: string): Promise<Lead> {
  const { data } = await apiClient.get<Lead>(`/leads/${id}`);
  return data;
}

export async function createLead(payload: LeadCreateInput): Promise<Lead> {
  const { data } = await apiClient.post<Lead>("/leads", payload);
  return data;
}

export async function updateLead(id: string, payload: Partial<Lead> & { sendTrialInvite?: boolean }): Promise<Lead> {
  const { data } = await apiClient.patch<Lead>(`/leads/${id}`, payload);
  return data;
}

export async function changeLeadStage(id: string, stage: LeadStage, lostReason?: string): Promise<Lead> {
  const { data } = await apiClient.patch<Lead>(`/leads/${id}`, { stage, lostReason });
  return data;
}

export async function suggestGroupsForLead(leadId: string): Promise<GroupSuggestion[]> {
  const { data } = await apiClient.get<GroupSuggestion[]>(`/leads/${leadId}/suggest-groups`);
  return data;
}

export async function convertLead(id: string, payload: LeadConvertInput): Promise<Lead> {
  const { data } = await apiClient.post<Lead>(`/leads/${id}/convert`, payload);
  return data;
}
